import * as ViewModel from '@/core/presenter/viewModel';
import 'bootstrap-icons/font/bootstrap-icons.css';
import clsx from 'clsx';
import { showTokenTransactionPopup, showTrxTransactionPopup } from '@/core/presenter/controller/PopupController';
import { useCallback } from 'react';

interface IProps {
  activity: ViewModel.IResponseActivity;
}

const ActivityItem = ({ activity }: IProps): JSX.Element => {
  const handleClickActivityItem = useCallback(() => {
    if (activity.coinType === ViewModel.AssetType.DBS) showTokenTransactionPopup(activity);
    else showTrxTransactionPopup(activity);
  }, [activity]);

  const handleCopyClick = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
    // 이벤트 전파 방지
    e.preventDefault();
    e.stopPropagation();

    const text = activity.type === '보내기' ? activity.to : activity.from;
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <li data-type={activity.type} onClick={handleClickActivityItem}>
        <a href="#">
          <div className="date">{activity.date}</div>
          <div className="row">
            <div className="left">
              <div className="icotxt">
                <div className="icon-area">
                  <img src={`img/con-${activity.imgType.toLowerCase()}-icon.png`} alt={`${activity.imgType}-icon`} />
                </div>
                <p className="mn-gray i-txt">{activity.coinType}</p>
              </div>
              <div className="txt-box">
                <div className="top">
                  <div className="sendOrReceiveAndButton-wrap">
                    <p className="body-l">{activity.type}</p>
                    <div
                      className={clsx('bottom status', {
                        success: activity.status === '성공',
                        fail: activity.status === '실패',
                      })}
                    >
                      {activity.status}
                    </div>
                  </div>
                  <div className="linkAndMemo">
                    <div className="destination">
                      <i
                        className={clsx(
                          'bi',
                          {
                            'bi-arrow-right-short': activity.type === '보내기',
                            'bi-arrow-left-short': activity.type === '받기',
                          },
                          'body-xl ml-gray',
                        )}
                      ></i>
                      <p className="body-n" onClick={handleCopyClick}>
                        {activity.type === '보내기' ? activity.to_short : activity.from_short}
                      </p>
                      <i className="bi bi-files" onClick={handleCopyClick}></i>
                    </div>
                    <span className="activity-memo body-s-n">
                      {activity.type === '보내기' ? activity.to_memo : activity.from_memo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              <div className="top">
                <p className="body-xl">{activity.amount}</p>
                <span className="ml-gray i-txt">{activity.krwAmount}</span>
              </div>
            </div>
          </div>
        </a>
      </li>
    </>
  );
};

export default ActivityItem;
